module.exports = __webpack_public_path__ + "static/img/icon8.0c526a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/App/icon8.png
// module id = IK/l
// module chunks = 1